import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export const Context = /*#__PURE__*/React.createContext(new Map());
export const Provider = function ({
  children
}) {
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: new Map()
  }, children);
};
export const withSmartCardStorage = WrappedComponent => {
  return class extends React.Component {
    render() {
      return /*#__PURE__*/React.createElement(Context.Consumer, null, storage => /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
        smartCardStorage: storage
      })));
    }
  };
};